import { readServices } from './read'

export const services = {
  read: readServices,
}
